import React,{Component} from 'react';

export class FooterContactSection extends Component {
	render(){
		return (
			<div className="contact-section">
				<div className="container">
				<div className="notice-box">
				<h4>Important Notice about Service</h4>
				<p>OSAH&rsquo;s ePortal currently does not support service of documents on the parties.  Submitting the document via OSAH&rsquo;s ePortal only ensures that the document is submitted to and received by OSAH.  You are still required to simultaneously serve opposing parties with your documents in accordance with the applicable law.  You must also submit to OSAH proof of service, the same as you would do if you were filing traditional paper documents.  In most instances, the last page of your eFiled document should include a &ldquo;Certificate of Service&rdquo; stating the date, place, and manner of service, as well as the names and addresses of the persons served.
					 <a className="notice-link" href="https://eportal.osah.ga.gov/eService requirements/administrative_rules_osah.pdf" target="_blank"> <span>Click here</span> review OSAH&rsquo;s Service Rule, 616-1-2-.11.</a>     <a className="notice-link" href="https://eportal.osah.ga.gov/eService requirements/Certificate%20of%20Service%20form_2019_08_21.pdf" target="_blank"> <span>Click here</span> for a sample Certificate of Service. </a>  
					</p>
				</div>
					
					<p><i className="fa fa-envelope" aria-hidden="true"></i> If you are having issues, please contact <a>publicportal@osah.ga.gov</a></p>
				</div>
			</div>
		)
	}
}
